"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostPriority = void 0;
var PostPriority;
(function (PostPriority) {
    PostPriority["URGENT"] = "urgent";
    PostPriority["IMPORTANT"] = "important";
})(PostPriority || (exports.PostPriority = PostPriority = {}));
